import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/park-spcod/prnpolicyconsultreply/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getPage = (current, size, params) => {
  return request({
    url: '/api/park-spcod/prnpolicyconsultreply/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/park-spcod/prnpolicyconsultreply/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/park-spcod/prnpolicyconsultreply/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/park-spcod/prnpolicyconsultreply/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/park-spcod/prnpolicyconsultreply/submit',
    method: 'post',
    data: row
  })
}

export const updateReply = (id) => {
  return request({
    url: '/api/park-spcod/prnpolicyconsultreply/updateconsultreply/'+id,
    method: 'post',
    data: {}
  })
}

export const addReply = (row) => {
  return request({
    url: '/api/park-spcod/prnpolicyconsultreply/submit',
    method: 'post',
    data: row
  })
}
